export default [
    {
        component: () => import(/* webpackChunkName: 'cadastro-supervisor' */ '@/views/cadastro/supervisor/Index'),
        path: 'supervisor',
        redirect: 'supervisor/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'cadastro-supervisor-index' */'@/views/cadastro/supervisor/List.vue'),
                name: 'cadastro-supervisor-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-supervisor' */ '@/views/cadastro/supervisor/Form.vue'),
                name: 'cadastro-supervisor-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-supervisor' */ '@/views/cadastro/supervisor/Form.vue'),
                name: 'cadastro-supervisor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]